import { useEffect, useState } from 'react'
import { appApi } from '../../services/appApi'
import { getToken } from '../../services/token'

interface iPermissaoLog {
  carregando: boolean
  permitido: boolean
  todasEmpresas: boolean
}

let cache: { token: string, permitido: boolean, todasEmpresas: boolean } | null = null

export function usePermissaoLog(): iPermissaoLog {
  const token = getToken()
  const emCache = cache?.token === token ? cache : null
  const [Estado, setEstado] = useState<iPermissaoLog>({
    carregando: !emCache,
    permitido: emCache?.permitido ?? false,
    todasEmpresas: emCache?.todasEmpresas ?? false
  })

  useEffect(() => {
    if (emCache !== null || token === '') return
    appApi.get('/Auditoria/Permissao')
      .then(res => {
        cache = { token, permitido: !!res.data.permitido, todasEmpresas: !!res.data.todasEmpresas }
        setEstado({ carregando: false, permitido: cache.permitido, todasEmpresas: cache.todasEmpresas })
      })
      .catch(() => setEstado({ carregando: false, permitido: false, todasEmpresas: false }))
  }, [token])

  return Estado
}
